// extracted by mini-css-extract-plugin
module.exports = {"form":"login_form-module__form--3UqZI"};